import Feature1 from "../../images/Svg/Feature1.svg";
import PastIcon from "../../images/Svg/Past.svg";

const FeatureData = [
  {
    id: 1,
    icon: Feature1,
    title: "Real-Time Sync",
    description: `Future posts will be synced <br /> automatically, once you subscribe`,
  },
  {
    id: 2,
    icon: PastIcon,
    title: "Sync Past Content",
    description: `Posted Content will be synced <br /> according to your preference`,
  },
];

export default FeatureData;
